import axios from "axios";
import { API_URL } from "./index";

export default
    {
        SaveBolParaCampaignResponse(token, campaignID, data) {
            return axios({
                method: 'post',
                url: `${API_URL}flow/save-bol-para-campaign-response`,
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                data: {
                    campaignID: campaignID,
                    data: data
                }
            });
        },
        GetBolParaCampaign(token, campaignID) {
            return axios({
                method: 'post',
                url: `${API_URL}flow/get-bolpara-campaign`,
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                data: {
                    campaignID: campaignID
                }
            });
        },
        GetBolParaCompanies(token) {
            return axios({
                method: 'post',
                url: `${API_URL}flow/get-bol-para-companies`,
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });
        },

        GetBolParaCampaignHasCoupon(token, companyID, campaignID) {
            return axios({
                method: 'post',
                url: `${API_URL}flow/bol-para-has-coupon`,
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                data: {
                    companyID,
                    campaignID
                },
            });
        },

        GetBolParaCoupon(token, companyID, campaignID, poiID) {
            console.log(poiID)
            return axios({
                method: 'post',
                url: `${API_URL}flow/bol-para-get-new-coupon`,
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                data: {
                    companyID,
                    campaignID,
                    poiID,
                    viewedType: "form"
                }
            });
        },
        BolParaAboutToken(token) {
            return axios({
                method: 'post',
                url: `${API_URL}flow/about-token`,
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },

            });
        }
    }